module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAA2SURBVHgB3ZDBCQAwCAPTTtLpsnY7ShF8xof4EQ/ERwghAQQkr53SNpI0NKyg3PH/ygmS6bN+tXALaUBwcUAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Vector.png
// module id = bNWQ
// module chunks = 1